import { render } from "./TutorialComp.vue?vue&type=template&id=4eb46531&scoped=true"
const script = {}

import "./TutorialComp.vue?vue&type=style&index=0&id=4eb46531&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb46531"]])

export default __exports__